import React from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import Cards, {CallbackArgument, Focused} from 'react-credit-cards';
import {CreditCardInformation} from './MasterPaymentForm';
import styles from './MasterPaymentForm.module.scss';

interface CreditCardFieldsProps {
  creditCardInformation: CreditCardInformation;
  issuer: string;
  focused?: Focused;
  handleCallback: ({issuer}: CallbackArgument, isValid: boolean) => void;
  handleInputFocus: ({target}: any) => void;
  handleInputChange: (e: any) => void;
}

class CreditCardFields extends React.Component<CreditCardFieldsProps> {
  render() {
    return (
      <div className={styles['cvc']}>
        <Row>
          <Col style={{display: 'flex', justifyContent: 'center'}}>
            <h2 className='text-center' style={{marginBottom: '1rem', display: 'inline-block'}}>Credit Card Details</h2>
          </Col>
        </Row>
        <Row>
          <Col lg={true} xl={{span: 5, offset: 1}}>
{React.createElement(Cards as any, {
              number: this.props.creditCardInformation.cardNumber.replace(/\d{4}(?= \d{4})/g, '****'),
              name: this.props.creditCardInformation.accountHolder,
              expiry: this.props.creditCardInformation.expiry,
              cvc: this.props.creditCardInformation.cvc,
              focused: this.props.focused,
              callback: this.props.handleCallback,
              preview: true
            })}
          </Col>
          <Col xl={{span: 5, offset: 0}} lg={{span: 6, offset: 6}} style={{margin: 'auto'}}>
            <Row>
              <Col style={{marginTop: '1rem'}}>
                <Form.Group controlId='number'>
                  <Form.Control
                    type='text'
                    name='number'
                    placeholder='Card Number'
                    aria-label='Card Number'
                    pattern='[\d| ]{16,22}'
                    required={true}
                    onChange={this.props.handleInputChange}
                    onFocus={this.props.handleInputFocus}
                    maxLength={19}
                    value={this.props.creditCardInformation.cardNumber.length >= 19 ? this.props.creditCardInformation.cardNumber.replace(/\d{4}(?= \d{4})/g, '****') : this.props.creditCardInformation.cardNumber}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={true}>
                <Form.Group controlId='name'>
                  <Form.Control
                    type='text'
                    name='name'
                    placeholder='Name'
                    aria-label='Name'
                    required={true}
                    onChange={this.props.handleInputChange}
                    onFocus={this.props.handleInputFocus}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={8}>
                <Form.Group controlId='expiry'>
                  <Form.Control
                    type='tel'
                    name='expiry'
                    placeholder='Valid Thru'
                    aria-label='Valid Thru'
                    pattern='\d\d/\d\d'
                    required={true}
                    onChange={this.props.handleInputChange}
                    onFocus={this.props.handleInputFocus}
                  />
                </Form.Group>
              </Col>
              <Col xs={4} style={{display: 'none'}}>
                <Form.Group controlId='cvc'>
                  <Form.Control
                    type='tel'
                    name='cvc'
                    placeholder='CVC'
                    aria-label='CVC'
                    pattern='\d{3,4}'
                    required={false}
                    onChange={this.props.handleInputChange}
                    onFocus={this.props.handleInputFocus}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Control type='hidden' name='issuer' value={this.props.issuer}/>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CreditCardFields;
